import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faStackOverflow, faGithub } from "@fortawesome/free-brands-svg-icons"


const PersonalInfo = () => {
	return (
		<div className="row pt-2">
			<div className="col-md-3 col-3 text-center">
				<p className="py-2"><FontAwesomeIcon className="fa-2x ContactLogo" icon={faPhoneAlt} /></p>

			</div>
			<div className="col-md-9 col-9 PersonalInfoConte">
				<p className="pt-2">
					<a href='tel:+91-7090631200'>+91-7090631200</a></p>
			</div>
			<div className="col-md-3 col-3 text-center">
				<p className="py-2"><FontAwesomeIcon className="fa-2x ContactLogo" icon={faEnvelope} /></p>
			</div>
			<div className="col-md-9 col-9 PersonalInfoConte">
				<p className="pt-3 emailContent">
					<a href='mailto:nadpurohitprasan009@gmail.com'>nadpurohitprasan009@gmail.com</a></p>
			</div>
			<div className="col-md-3 col-3 text-center">
				<p className="py-2"><FontAwesomeIcon className="fa-2x ContactLogo" icon={faMapMarkerAlt} /></p>
			</div>
			<div className="col-md-9 col-9 PersonalInfoConte">
				<p className="pt-2 emailContent">
					<a href=' http://maps.google.com/?q=Belgaum Karnataka' rel="noreferrer" target='_blank'>Belgaum Karnataka</a></p>
			</div>
			<div className="col-md-3 col-3 text-center">
				<p className="pt-4"><FontAwesomeIcon className="fa-2x ContactLogo" icon={faStackOverflow} /></p>
			</div>
			<div className="col-md-9 col-9 PersonalInfoConte">
				<p className="pt-2 emailContent"><a href="https://stackoverflow.com/users/12916691/codebug" rel="noreferrer" target='_blank'>
					https://stackoverflow.com/users/12916691/codebug
				</a></p>
			</div>
			<div className="col-md-3 col-3 text-center">
				<p className="pt-3"><FontAwesomeIcon className="fa-2x ContactLogo" icon={faGithub} /></p>
			</div>
			<div className="col-md-9 col-9 PersonalInfoConte">
				<p className="pt-2 emailContent">
					<a href="https://github.com/designerprasan007" target='_blank' rel="noreferrer">
						https://github.com/designerprasan007
					</a>
				</p>
			</div>
		</div>
	)
}

export default PersonalInfo